module.exports = __webpack_public_path__ + "img/chest_freezer.eca9d0dd.jpg";